import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logo from './logo-full.svg';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var KawasakiLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { src: logo, alt: strings.app.name });
};
